import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import styles from './style.module.scss';
import classNames from 'classnames';
import Heading from 'shared/components/common/heading/Heading';
import CustomInput from 'shared/components/common/custom_input/CustomInput';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import { useSelector } from 'react-redux';
import { AddCategoryMutation, UpdateCategoryMutation } from 'shared/services/category_service/CategoryService';
import OverlayLoading from 'shared/screen_loader/overlay_loader/OverlayLoading';
import { CategoryVS } from 'shared/utils/validation/AuthValidation';
import { useFormik } from 'formik';
import { toastMessage } from 'shared/components/toast/Toast';

export default function AddCategory({ show, datatable, handleClose, isEdit = false, editData = null, onSuccessAdd }) {
    const { mutate: addCategoryMutate, isLoading: CategoryLoading, isSuccess: CategoryIsSuccess } = AddCategoryMutation();
    const { mutate: updateCategoryMutate, isLoading: UpdateCategoryLoading, isSuccess: UpdateCategoryIsSuccess } = UpdateCategoryMutation();
    const {
        theme: { theme }
    } = useSelector((state) => state.root);

    useEffect(() => {
        if ((CategoryIsSuccess || UpdateCategoryIsSuccess) && show) {
            if (onSuccessAdd) onSuccessAdd(values.name);
            onClose();
        }
    }, [CategoryIsSuccess, UpdateCategoryIsSuccess]);

    const onClose = () => {
        handleClose();
        formik.resetForm();
    };

    const initialValues = {
        name: isEdit && editData?.name ? editData.name : '',
        brand: ''
    };
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: initialValues,
        validationSchema: CategoryVS,
        onSubmit: (value) => {
            categoryHandler(value);
        }
    });

    const { handleChange, handleSubmit, values, touched, errors } = formik;

    const categoryHandler = (values) => {
        const isDuplicate = datatable?.some(
            (category) =>
                category._id !== editData?._id &&
                category.name.trim().toLowerCase() === values.name.trim().toLowerCase()
        );

        if (isDuplicate) {
            toastMessage('error', `Category "${values.name}" already exists!`);
            return;
        }

        if (isEdit && editData?._id) {
            updateCategoryMutate({ id: editData._id, payload: { name: values.name } });
        } else {
            addCategoryMutate({ name: values.name });
        }
    };

    return (
        <Modal show={show} onHide={handleClose} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header className={styles.Header}>
                <Heading heading={isEdit ? 'Edit Category' : 'Add Category'} headingStyle={styles.AddLinkHeading} />
            </Modal.Header>
            <Modal.Body className={classNames(`${theme}ModalBackground`, styles.Body)}>
                <div className={classNames(styles.AddLinkContainer)}>
                    <CustomInput
                        label={isEdit ? 'Edit Category Name' : 'Add Category'}
                        placeholder={'e.g. Category'}
                        CustomInputStyle={classNames(`${theme}ItemBackground`, styles.CustomInputStyle)}
                        CustomLabelStyle={styles.CustomLabelStyle}
                        InputContainerStyle={styles.InputContainerStyle}
                        value={values.name}
                        onChange={handleChange('name')}
                        error={errors.name && touched.name ? errors.name : ''}
                    />

                    <div className="d-flex justify-content-end">
                        <CustomButton text={'Cancel'} containerStyle={styles.CancelBtn} submitHandle={onClose} />
                        <CustomButton text={isEdit ? 'Update' : 'Add'} containerStyle={styles.SubmitBtn} submitHandle={handleSubmit} />
                    </div>
                </div>
                {(CategoryLoading || UpdateCategoryLoading) && <OverlayLoading />}
            </Modal.Body>
        </Modal>
    );
}
